import { Component, Injectable } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GalerieService, PhotoGalerie } from 'src/app/core/services/entities/galerie.service';

/** Fenêtre « Galerie Wanar » : la grille et ses filtres, un clic choisit la photo */
@Component({
  selector: 'bay-galerie-selection',
  template: `
    <div class="modal-header">
      <h2 class="modal-title h5 fw-bold mb-0">
        <span class="material-symbols-outlined align-middle me-1" style="color:#0d631b;" aria-hidden="true">photo_library</span>Galerie Wanar
      </h2>
      <button type="button" class="btn-close" aria-label="Fermer" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body" data-etat="selecteur-galerie">
      <p class="small text-muted">Choisissez une photo déjà prise : elle reste aussi dans la Galerie.</p>
      <bay-galerie [selection]="true" (choisir)="modal.close($event)"></bay-galerie>
    </div>
  `
})
export class GalerieSelectionComponent {
  constructor(public modal: NgbActiveModal) {}
}

/** Sélecteur de photo « Galerie Wanar », à côté de l'envoi de fichier */
@Injectable({ providedIn: 'root' })
export class GalerieSelecteurService {
  constructor(private modal: NgbModal, private galerie: GalerieService) {}

  /** Photo choisie, ou null si la fenêtre est fermée */
  choisir(): Promise<PhotoGalerie | null> {
    const ref = this.modal.open(GalerieSelectionComponent, { size: 'xl', scrollable: true, windowClass: 'bay-modal-galerie' });
    return ref.result.then(p => p || null, () => null);
  }

  /** Photo choisie en fichier (image d'affichage) pour l'IA, une facture ou une pièce ; null si annulé */
  async choisirFichier(): Promise<File | null> {
    const p = await this.choisir();
    return p ? this.galerie.fichierAffichage(p).toPromise() : null;
  }
}
